// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"776bae8f","320":"be863941","412":"eb72f600","744":"1dfb9a32","917":"830e93b1"}[chunkId] + ".chunk.js";
};